{
  "alerts": {
    "cantCreateProperty": "Fel, det gick inte att uppdatera bostadsinformationen. Försök igen senare.",
    "cantCreateUser": "Fel, det gick inte att skapa användaren. Försök igen senare.",
    "cantCancelReservation": "Fel, bokningen kunde inte avbokas. Försök igen senare.",
    "cantCancelSubscription": "Fel, prenumerationen kunde inte avslutas. Försök igen senare.",
    "cantUpdate": "Fel, det gick inte att uppdatera informationen. Försök igen senare.",
    "cantUpdateReservtion": "Det gick inte att uppdatera bokningen. Försök igen senare eller kontakta oss.",
    "emailIsIncorrect": "E-postadressen är ogiltig. Se till att den angivna adressen är korrekt skriven",
    "googlePlayServicesNotAvailable": "Google Play-tjänster är inte tillgängliga på din enhet.",
    "locationNotEnabledDescription": "Du måste aktivera platsen för att kunna utföra beställningar.",
    "locationNotEnabledTitle": "Aktivera platsen",
    "mandatoryUpdateMessage": "Det finns en obligatorisk uppdatering som måste installeras.",
    "outdatedPaymentMethod": "Den valda betalningsmetoden är inaktuell. Uppdatera betalningsmetoden och försök igen.",
    "paymentFailed": "Ett fel inträffade under betalningen.\nKontakta supporten eller försök igen.",
    "sthWentWrong": "Fel, något gick fel.\nKontakt support eller prøv igjen.",
    "unavailableLocalization": "Din plats är ännu inte tillgänglig",
    "update": "Uppdatera",
    "updateTitle": "Tillgänglig uppdatering",
    "userWithEmailAlreadyExists": "Användaren med denna e-postadress finns redan"
  },
  "common": {
    "accept": "Acceptera",
    "add": "Lägg till",
    "added": "Tillagd",
    "at": "kl.",
    "cancel": "Avbryt",
    "chat": "Chat",
    "change": "Ändra",
    "choose": "Välj",
    "choosePhoto": "Välj foto",
    "chosen": "Vald",
    "clear": "Rensa",
    "close": "Stäng",
    "closePage": "Stäng sida",
    "continue": "Fortsätt",
    "date": "Datum",
    "default": "Standard",
    "delete": "Radera",
    "deleteService": "Ta bort %{service}",
    "details": "detaljer",
    "discount": "Rabatt",
    "done": "Klart",
    "edit": "Redigera",
    "error": "Fel",
    "email": "E-post",
    "from": "Från",
    "goBack": "Gå tillbaka",
    "help": "Hjälp",
    "hi": "Hej! 👋",
    "hours": "tim.",
    "id": "ID",
    "menu": "Meny",
    "name": "Namn",
    "no": "Nej",
    "OK": "OK",
    "or": "Eller",
    "order": "Beställning",
    "phone": "Telefonnummer",
    "popular": "Populär",
    "price": "Pris",
    "return": "Tillbaka",
    "save": "Spara",
    "service": "Tjänst",
    "skip": "Hoppa över",
    "stripe": "Stripe",
    "takePhoto": "Ta foto",
    "time": "Tid",
    "together": "Tillsammans",
    "tryAgain": "Försök igen",
    "understand": "Jag förstår",
    "update": "Uppdatera",
    "whether": "Oavsett om",
    "yes": "Ja"
  },
  "components": {
    "drawer": {
      "aboutStepapp": "Om Stepapp",
      "coupons": "Kuponger",
      "covid19": "Vårt svar på Covid-19",
      "covid19Response": "Svar på Covid-19",
      "downloadApp": "Ladda ner appen",
      "help": "Hjälp",
      "hey": "Hej! ",
      "heyYou": "Hej %{name}!",
      "payments": "Betalningsmetoder",
      "referAFriend": "Referera en vän",
      "settings": "Inställningar",
      "showProfile": "Visa profil",
      "support": "Support",
      "writeToUs": "Skriv till oss"
    },
    "footer": {
      "about": "Om oss",
      "app": "App",
      "blog": "Blogg",
      "cancellationRules": "Avbokningsregler",
      "cleaningPersonnel": "Städpersonal",
      "contact": "Kontakta oss",
      "contactHours": "Mån-lör 9:30-18:00",
      "cookies": "Vi använder kakor för att vår webbplats ska fungera korrekt.",
      "daysAgo": "dagar sedan",
      "disclaimerPL": "Stepapp är Stepapp sp. z.o.o. registrerat i Warszawa. Registrerat i den nationella domstolsregistret under nummer 0000896336. Momsregistreringsnummer: 5252860294.",
      "disclaimerNO": "Stephome AS registrerad i Oslo.",
      "FAQ": "Frågor och svar",
      "learnMore": "Läs mer",
      "myths": "Myter om städning",
      "privacyPolicy": "Integritetspolicy",
      "reviews": "Recensioner om Stepapp",
      "safePayment": "Säker betalning",
      "termsOfUse": "Användarvillkor",
      "today": "idag",
      "workers": "Städpersonal",
      "worthKnowing": "Värt att veta",
      "yesterday": "igår"
    },
    "header": {
      "aboutStepapp": "Om Stepapp",
      "coupons": "Kuponger",
      "help": "Hjälp",
      "inviteFriends": "Bjud in vänner",
      "payments": "Betalningar",
      "profile": "Profil",
      "register": "Registrera",
      "services": "Tjänster",
      "settings": "Inställningar",
      "showProfile": "Visa profil",
      "signIn": "Logga in",
      "support": "Support",
      "writeToUs": "Skriv till oss"
    },
    "input": {
      "placeholder": {
        "additionalInstructions": "Exempel: Var vänlig knacka på dörren istället för att använda dörrklockan.",
        "addNote": "Lägg till en anteckning (valfritt)",
        "addressFirstLine": "Adress rad 1",
        "addressSecond": "Andra adressraden",
        "addressSecondLine": "Adress rad 2",
        "apartmentNumber": "Lägenhet",
        "city": "Stad",
        "companyName": "Företagsnamn",
        "doorCode": "Portkod",
        "email": "E-post",
        "firstName": "Ditt förnamn",
        "homeDescription": "T.ex. vad du vill att vi ska tänka på vid städning?",
        "housing": "Bostadsområde",
        "keyInfo": "Var kommer du lämna nyckeln? T.ex. “Nyckeln kommer att vara under den lila blomkrukan till vänster om dörren“",
        "lastName": "Ditt efternamn",
        "NIPNumber": "NIP-nummer",
        "postalCode": "Postnummer",
        "propertyName": "Fastighetsnamn",
        "size": "Storlek",
        "street": "Gata",
        "typeAddress": "Ange adress"
      }
    },
    "houseAreaOutOfScope": {
      "houseAreaIsTooLarge": "Den angivna husytan är för stor.",
      "orderForLargerHouseArea": "Vill du beställa städning för en större yta? Kontakta oss!",
      "writeAndOrderCustomCleaning": "Jag vill beställa en anpassad städning"
    },
    "paymentOptions": {
      "type_apple": "Apple Pay",
      "type_google": "Google Pay"
    },
    "shareCouponSheet": {
      "copy": "Kopiera",
      "description": "Få %{providerReward} för varje rekommenderad\nvän som beställer sin första\ntjänst. De får %{receiverReward}\nfrån dig bara för att registrera sig!",
      "discountExplanation": "Minsta beställningsvärde - 100 kr.",
      "share": "Dela",
      "shareMessage": "Jag skickar dig %{codeValue} rabatt på din första städning i Stepapp-appen. För att använda det, ange koden %{referralCode} när du lägger en order! \nLänk till orderläggning: %{appUrl}",
      "title": "Goda vänner ger Stepapp"
    },
    "tabBar": {
      "application": "Ansökan",
      "calendar": "Kalender",
      "dashboard": "Beställ",
      "myHome": "Mitt hem",
      "openApp": "Öppna appen",
      "stepappApp": "Stepapp-appen",
      "stepappAppDescription": "Ladda ner vår mobilapp för att hålla koll på dina beställningar och inte missa erbjudanden och meddelanden från vår support!",
      "stepappMobileApp": "Stepapp mobilapp"
    },
    "tabBar_Calendar": "Kalender",
    "tabBar_Dashboard": "Beställ",
    "tabBar_MyHome": "Mina adresser"
  },
  "dialogs": {
    "couponActivated": "Kampanjkoden har aktiverats",
    "couponAdded": "Stepapp plånboken har laddats med %{amount}",
    "couponCreditsAdded": "Din plånbok har fyllts på med nya krediter att använda i Stepapp-applikationen.",
    "couponFindOtherAndTryAgain": "Eller så är det felaktigt. Kontrollera om det finns några stavfel och försök igen.",
    "couponInvalid": "Koden \"%{coupon}\" är ogiltig eller inaktuell",
    "couponUsed": "Koden har redan använts",
    "later": "Senare",
    "multiPersonServiceInfoMessage": "Kom ihåg att en bokning är kopplad till en tjänsteleverantör. Om du bokar en tjänst för fler än en person kommer samma person att utföra tjänsterna en efter en. Om du vill boka för två personer samtidigt måste du lägga två separata beställningar och nämna det i anteckningarna till beställningen.",
    "multiPersonServiceInfoTitle": "Information om tjänster för fler än en person",
    "negativeRateTitle": "Skriv till oss vad vi absolut kan ändra eller förbättra. Det kommer att hjälpa oss mycket!",
    "ofCourse": "Självklart",
    "positiveRateTitle": "Fantastiskt! 🤘 Vänligen betygsätt vår\napp. Vi kommer att vara mycket\ntacksamma!",
    "rateTitle": "Gillar du Stepapp\nappen?"
  },
  "notifications": {
    "accountDeletion": {
      "description": "En process för att ta bort ditt konto har påbörjats. Det kan ta upp till 7 dagar.",
      "title": "Konto under borttagning"
    },
    "permissionDenied": {
      "camera": "Du har inte behörighet för kameran.",
      "cameraDescription": "Gå till appinställningarna för att tillåta kameran.",
      "notifications": "Aktivera aviseringar i appinställningarna",
      "notificationsDescription": "Vi använder aviseringar för att leverera uppdateringar relaterade till uppdraget. Utan att aktivera dem kan appen fungera felaktigt."
    }
  },
  "pages": {
    "auth": {
      "basicInfoDescription": "Vi ber dig bara om nödvändig information.\nDin e-postadress och ditt efternamn kommer endast att vara synliga för oss.",
      "registerInStepapp": "Registrera dig i Stepapp."
    },
    "chooseCard": {
      "addCard": "Lägg till kort",
      "addCardFailed": "Kortet kunde inte läggas till",
      "addCardFailedDescription": "Kontrollera angivna uppgifter eller försök igen senare",
      "cardRecurringPaymentsInfo": "Ditt kort kommer att kopplas till ditt Stepapp-konto och användas för återkommande betalningar i prenumerationen. Du kan alltid ändra det i inställningarna.",
      "cardNotSupportThisPayment": "Ditt kort stöder inte denna betalningstyp. Försök att lägga till ett annat kort.",
      "chooseCard": "Välj kort",
      "confirm": "Bekräfta",
      "newCard": "Nytt kort"
    },
    "serviceDateAndAddress": {
      "addAddress": "Lägg till adress",
      "addAddressDescription_cleaning": "Ange detaljerad information så att vi kan börja städningen utan hinder.",
      "addAddressDescription_massage": "Ange detaljerad information så att vi kan börja massagen utan hinder.",
      "addAddressDescription_other": "Ange detaljerad information så att vi kan börja tjänsten utan hinder.",
      "additionalInfo": "Ytterligare information",
      "addressForm": {
        "address": "Gatuadress och husnummer",
        "addressSecond": "Andra adressraden",
        "city": "Stad",
        "doorCode": "Dörrkod",
        "iWillBeThere": "Jag kommer att vara där",
        "iWillLeaveTheKey": "Jag lämnar nyckeln",
        "numberOrHousing": "Nummer eller bostad",
        "postalCode": "Postnummer"
      },
      "chooseHour": "Välj timme",
      "continueLabel": "Fortsätt - Sammanfattning och betalning",
      "description": "Välj datum och tid för start av tjänsten",
      "howAreWeGoingToEnter": "Hur kommer vi in i din lägenhet?",
      "howAreWeGoingToEnterDescription": "Detta är frivillig information som hjälper oss att rengöra utan hinder. Du kan alltid lägga till det senare.",
      "instructionsForArrival": "Instruktioner för ankomst",
      "iWillBeThere": "Jag kommer att vara där",
      "iWillLeaveTheKey": "Jag lämnar nyckeln",
      "provideAddress": "Ange adress",
      "provideAddressTitle": "Ange leveransadress för tjänsten",
      "provideAddressToCheckAvailability": "Genom adressen kommer vi att kunna fastställa tillgängligheten för våra tjänster",
      "title": "När börjar vi?"
    },
    "serviceSummary": {
      "addCard": "Lägg till kort",
      "additionalServices": "Ytterligare tjänster",
      "address": "Adress",
      "cancellationRules": "Avbokningsregler",
      "cancellationRulesDescription": "Avboka före %{date} för att undvika extra kostnader. Avbokning efter detta datum kommer att medföra extra kostnader upp till 50% av beställningsvärdet.",
      "cardDescription": "Vi kommer att reservera medlen först 48 timmar före städningen. Betalningen kommer dock att dras först på dagen för städningen.",
      "couponList": "Rabattkuponglista",
      "dateNotAvailable": "Det valda datumet är redan otillgängligt. Gå tillbaka till kalendern och välj en ny städdag.",
      "description": "Gå igenom din beställning igen och kontrollera att allt stämmer",
      "doYouNeedVATInvoice": "Behöver du en moms faktura?",
      "enterCoupon": "Ange kupong",
      "haveCoupon": "Har du en kupong?",
      "haveCouponDescription": "Du kan lägga till en kupong efter inloggning eller registrering.",
      "howAreWeGoingToEnter": "Hur ska vi komma in i din lägenhet?",
      "instantPaymentCardDescription": "Vi kommer att debitera hela beloppet direkt efter att beställningen har lagts, eftersom det är mindre än 48 timmar kvar tills din beställning ska utföras.",
      "instantPaymentInfo": "Pengarna dras omedelbart från ditt kort eftersom det är mindre än 48 timmar kvar tills tjänsten ska påbörjas.",
      "instantPaymentRules": "Din bokning kommer att börja tidigare än 48 timmar. Avbokning efter denna tid kommer att medföra extra kostnader upp till 50% av ordervärdet.",
      "invoiceAdditionalEmail": "Du kan lägga till en extra e-postadress för fakturering här. Om du lämnar fältet tomt skickar vi fakturan till din kontos e-postadress.",
      "invoiceBeforeSubmit": "Detta kan endast göras innan du lägger din beställning.",
      "loginToViewDetails": "Logga in eller registrera dig för att lägga en beställning",
      "nextSteps": "Nästa steg",
      "nextStepsDescription_cleaning": "Efter att du har gjort din bokning kommer vi att tilldela en av våra fantastiska städare tillgänglig i ditt område. Du kommer att lära känna dem i appen innan städningen påbörjas.",
      "nextStepsDescription_massage": "Efter att du har gjort en bokning tilldelar vi en av våra massageterapeuter som är tillgänglig i ditt område. Du lär känna personen i appen innan tjänsten börjar.",
      "nextStepsDescription_other": "Efter att du har gjort en bokning tilldelar vi en av våra anställda som är tillgänglig i ditt område. Du lär känna personen i appen innan tjänsten börjar.",
      "pay_blik": "Betala med BLIK",
      "pay_przelewy24": "Betala med Przelewy24",
      "payNow": "Betala nu",
      "payNowDescription": "Kom ihåg att för regelbunden städning kommer vi att be dig lägga till ett kort för regelbundna städningar. Du kan fortfarande betala för din första städning med BLIK eller Przelewy24. Tyvärr tar vi inte emot kontantbetalningar.",
      "SMSInfo": "Vi skickar en sms-kod till det angivna telefonnumret. Ange koden för att bekräfta inloggning eller registrering.",
      "startDate": "Startdatum",
      "title": "Sammanfattning",
      "total": "Totalt att betala",
      "VATInvoice": "Fakturainformation",
      "VATInvoiceInfo": "Du kan lägga till faktureringsinformation längst ner på beställningen. Kom ihåg att göra detta <b> före du lägger din beställning </b>.",
      "wantToGetVATInvoice": "Jag vill ha en momsregistrerad faktura",
      "yourStepappWallet": "Din Stepapp-plånbok"
    }
  },
  "screens": {
    "accommodation": {
      "description": "Vi behöver veta vilken typ av boende du har för att kunna ge dig den bästa upplevelsen på Stepapp",
      "title": "Var bor du?",
      "type_APARTMENT": "I en lägenhet",
      "type_HOUSE": "I ett hus"
    },
    "appUpdate": {
      "description": "Vi har just släppt en ny, efterlängtad uppdatering av vårt system och app. Det har skett många förändringar, men nedan presenterar vi de viktigaste:",
      "feature1": "[Nytt] Möjlighet att redigera bokningar från appnivå, lägga till nya tjänster.",
      "feature2": "[Nytt] Möjlighet att ändra datumet på appnivå.",
      "feature3": "[Nytt] Smart tillgänglighetskalender",
      "feature4": "[Nytt] Apple Pay/Google Pay-betalningar.",
      "feature5": "[Nytt] Enklare betalningshantering.",
      "title": "Hej! Välkommen till Stepapp 2.0."
    },
    "auth": {
      "alreadyHaveAccount": "Har du redan ett konto?",
      "iHaveAccount": "Jag har redan ett konto",
      "inWhichCity": "I vilken stad vill du använda våra tjänster?",
      "letsStart": "Vi börjar",
      "logIn": "Logga in",
      "logInWith": "Logga in med %{provider}",
      "order": "Beställ tjänst",
      "register": "Registrera dig",
      "welcomeMessage": "Vi hjälper dig med dina hushållssysslor så att du får mer fritid varje dag!",
      "welcomeMessage1": "Vi hjälper dig med hushållssysslor, så att du får ",
      "welcomeMessage2": "mer fritid",
      "welcomeMessage3": " varje dag!",
      "whereDoYouLive": "Var bor du?"
    },
    "bookedServices": {
      "downloadApp": "Ladda ner Stepapp-appen",
      "emptyBookings": "Du har inga planerade tjänster. Beställ en tjänst i Stepapp och låt ditt hem sköta sig självt!",
      "order": "Beställ tjänst",
      "showCompleted": "Visa avslutade",
      "toTrackProgress": " för att följa dina bokningar i realtid."
    },
    "calendar": {
      "additionalCardVerification": "Kortet kan behöva extra verifiering.",
      "cantFindDate": "Ser du inte ett lämpligt datum?",
      "failedCardPayment": "Vi kunde inte dra betalningen från ditt kort",
      "hide": "Dölj",
      "notRegistered": "Här kan du som registrerad användare se dina framtida bokningar.",
      "paymentFailed": "Betalningen misslyckades",
      "paymentFailedDescription": "Uppdatera betalningsmetoden för att undvika skulder",
      "serviceScheduleInfo": "Vi visar bara de närmaste planerade tiderna. Senare tider kommer att visas efter avslutad service. Om du vill göra ändringar i senare tider,",
      "settlePayment": "Betala skulden",
      "showLaterReservations": "Visa senare bokningar",
      "title": "Mina bokningar",
      "updatePayment": "Uppdatera betalningsmetoden",
      "writeToUs": "skriv till oss."
    },
    "cancelReservation": {
      "addDiscount": "Lägg till det i din plånbok under 'Betalningar', så minskar betalningen för nästa tjänst i denna bokning med %{discount}.",
      "cancelAllScheduledAppointments": "Vi kommer att avboka alla schemalagda tider från detta abonnemang.",
      "cancelAppointment": "Avboka denna tid %{fee}",
      "cancelEntireSubscription": "Avbryt hela prenumerationen %{fee}",
      "cancelReservation": "Avboka bokningen",
      "cancelSubscription": "Avsluta prenumeration %{fee}",
      "cancelSingleReservationInSubscription": "Du avbokar endast en enskild tid (%{date}). En ny tid kommer att genereras enligt din abonnemangsfrekvens.",
      "cancelSubscriptionWithCost": "Du kan också avbryta hela prenumerationen, men du kommer fortfarande att debiteras för att avboka denna tid.",
      "cancelOrEditReservation": "Du kan avboka hela bokningen eller ändra datumet.",
      "confirmCancelReservation": "Ställ in denna tid %{fee}",
      "confirmCancelSubscription": "Avsluta prenumerationen %{fee}",
      "dontCancelAppointment": "Jag vill inte avboka tiden",
      "dontCancelSubscription": "Jag vill inte avsluta prenumerationen",
      "insteadOfPaying": "Istället för att betala %{fee}, kan du spara %{discount}!",
      "maybeConsiderResubscribe": "Kanske du vill överväga att prenumerera igen?",
      "newAddressDiscount": "Beställ städning på en ny adress med rabatt.",
      "nextServiceDiscount": "-%{discount} på nästa tjänst.",
      "reservationCanceled": "Bokningen avbokad.",
      "serviceCancellation": "Avbokning av tjänst.",
      "specialOffer": "Vi har förberett ett specialerbjudande för dig.",
      "staySubscribed": "Fortsätt prenumerera och ta del av erbjudandet",
      "subscriptionCanceled": "Prenumerationen avslutad.",
      "weWantToImprove": "Vi vill ständigt förbättras, och din åsikt är viktig.",
      "whyCancelReservation": "Varför vill du avboka bokningen?",
      "whyCancelSubscription": "Varför vill du avsluta prenumerationen?",
      "cancelCause": {
        "haveBetterOffer": "Jag har ett bättre erbjudande",
        "movingToANewPlace": "Jag flyttar till en ny plats",
        "noLongerNeedTheService": "Jag behöver inte längre tjänsterna",
        "other": "Annat",
        "problemWithPlatform": "Jag har ett problem med Stepapp-plattformen",
        "problemWithWorker": "Jag har ett problem med den tilldelade personen",
        "serviceNotGoodEnough": "Tjänsten motsvarar inte mina förväntningar"
      }
    },
    "chat": {
      "writeMessage": "Skriv ett meddelande"
    },
    "completedServices": {
      "completed": "Avslutade",
      "emptyCompleted": "Du har inga avslutade tjänster. Beställ en tjänst på Stepapp och sätt ditt hem på autopilot!",
      "title": "Avslutade Bokningar"
    },
    "coupons": {
      "addCoupons": "Lägg till i beställningen",
      "description": "Har du en rabattkod eller en Stepapp-plånbokskod?",
      "emptyCoupons": "Du har inga tillgängliga kuponger",
      "giveAndReceiveDiscount": "Ge 40 NOK, Få 40 NOK",
      "removeCoupons": "Ta bort från beställningen",
      "shareMailSubject": "Stepapp",
      "shareMessage": "Hej! Jag har 40 NOK gratis för dig i Stepapp! %{voucherCode}",
      "title": "Kuponger",
      "typeCode": "Ange kod",
      "validTo": "Giltigt till %{date}",
      "walletFundsDescription": "Medel från plånboken kommer att användas för att betala för nästa tjänst.",
      "yourDiscounts": "Dina rabatter"
    },
    "dashboard": {
      "articlesTitle": "Stepapp Blogg",
      "bookNow": "Boka nu",
      "chooseCategory": "Välj kategori",
      "chooseCity": "Välj stad",
      "couldntProcessPayment": "Vi kunde inte behandla betalningen för städningen",
      "hygiene": "Hygien",
      "hygieneDescription": "Vi har strikta hygienstandarder och noll tolerans för att bryta säkerhetsregler.",
      "insurance": "Ansvarsförsäkring",
      "insuranceDescription": "Varje beställning i Stepapp är täckt av en ansvarsförsäkring på 1 000 000 zł.",
      "liabilityInsurance": "Ansvarsförsäkring upp till 1 miljon zł",
      "mostPopularServices": "Mest populära tjänster",
      "proposeCity": "Föreslå stad",
      "reliability": "Pålitlighet",
      "reliabilityDescription": "Vi kontrollerar bakgrunden och erfarenheten hos alla personer som kommer in i våra kunders hem.",
      "reviewsWithRating": "%{reviews} recensioner med ett genomsnitt på %{rating}/5",
      "secureOnlineBooking": "Säker onlinebokning",
      "seeAllReviews": "Se alla recensioner",
      "seeMore": "Se mer",
      "servicesWithName": "Hej! 👋🏻 Hur kan vi ge dig mer frihet idag?",
      "startingPrice": "från %{price} kr",
      "testimonials": "recensioner",
      "title": "Beställ för",
      "trainedProfessionals": "Endast utbildade proffs",
      "yourSafetyPriority": "Din säkerhet är vår prioritet.",
      "verifiedAndTrained": "Vi kontrollerar och utbildar alla Stepapp-proffs"
    },
    "category": {
      "chooseYourService": "Välj din tjänst",
      "contactCustomerSupport": "Kontakta vår kundtjänstavdelning.",
      "easyOnlineBooking": "Enkel och snabb onlinebokning",
      "haveQuestions": "Har du några frågor?",
      "liabilityInsurance": "Ansvarsförsäkring upp till 1 000 000 PLN",
      "otherCategories": "Andra kategorier",
      "trainedProfessionals": "Utbildade proffs",
      "whatMakesUsDifferent": "Vad gör oss unika?"
    },
    "detailsForm": {
      "description": "Ditt namn och e-postadress kommer inte att vara synliga för andra.",
      "title": "Fyll i informationen."
    },
    "dismissBrowser": {
      "goBackToApp": "Gå tillbaka till appen."
    },
    "editProfile": {
      "aboutMe": "Om mig",
      "changePhoto": "Byt Foto",
      "title": "Redigera Profil",
      "updateInfo": "Uppdatera Information"
    },
    "flatSize": {
      "description": "Vi behöver veta storleken på din lägenhet för att visa dig lämpliga priser",
      "title": "Hur många m2?",
      "unit": "m2"
    },
    "fullScreenNotification": {
      "reservationButtonTitle": "Se Kalender",
      "reservationDescription": "Nu kan du se dem i din kalender och kontrollera arbetets framsteg.",
      "reservationTitle": "Fantastiskt! Din bokning har\naccepterats."
    },
    "homeDescription": {
      "description": "Det du skriver här kommer att skickas till din utförare",
      "title": "Lägg till instruktioner"
    },
    "homeEdit": {
      "addAddress": "Lägg till adress",
      "chooseFriendlyName": "Välj ett vänligt namn, t.ex. \"Mormor Gienis hus\". Detta namn syns endast för dig.",
      "confirmDeleteProperty": "Är du säker på att du vill ta bort bostaden?",
      "deleteProperty": "Ta bort bostaden",
      "editAddress": "Redigera adress",
      "exactAddress": "Exakt adress",
      "homeType": "Hemtyp",
      "notEditableNote": "Du kan endast ändra viss information",
      "postalCode": "Postnummer",
      "provideInformation": "Ange exakt adressinformation så att vi enkelt kan hitta till ditt hem.",
      "surface": "Yta",
      "type_APARTMENT": "Lägenhet",
      "type_HOUSE": "Hus",
      "whatsImportantNote": "Vad är viktigt i ditt hem när det gäller hushållssysslor?"
    },
    "location": {
      "description": "Vi kommer att kontrollera om Stepapp-tjänsterna är tillgängliga i ditt område",
      "title": "Ange ditt postnummer"
    },
    "login": {
      "alreadyRegistered": "Har du redan ett Stepapp-konto?",
      "and": "och",
      "firstTime": "Är det första gången du är här?",
      "logInWithAccount": "eller logga in på ditt konto.",
      "noAccRegister": "Har du inte ett Stepapp-konto ännu! Det är hög tid att ordna det!",
      "orderFirstService": "Beställ din första tjänst",
      "privacyPolicy": "Integritetspolicy",
      "registerTitle": "Nästan klart!\nLogga in eller registrera dig för att göra en beställning.",
      "registerYourAccount": "eller registrera ett nytt konto.",
      "selectingOneOfAbove": "Genom att välja en av ovanstående accepterar du våra",
      "social_apple": "Fortsätt med Apple",
      "social_default": "Fortsätt med telefonnummer",
      "social_facebook": "Fortsätt med Facebook",
      "social_google": "Fortsätt med Google",
      "termsOfUse": "Användarvillkor",
      "title": "Logga in eller registrera dig",
      "webRegisterTitle": "Nästan klar! Skapa ett konto på Stepapp eller logga in."
    },
    "maintenance": {
      "maintenanceBreak": "Underhållspaus",
      "maintenanceContactInfo": "Om du behöver kontakta vår support, skriv i chatten på %{landingPageUrl} eller maila till: %{supportEmail}",
      "maintenanceInProgress": "Vi genomför för närvarande en stor systemuppdatering, våra appar är för närvarande otillgängliga."
    },
    "myHome": {
      "addInfo": "Lägg till information",
      "addressNote": "Lägg till mer information om ditt hem så att vi bättre kan anpassa oss till dina behov.",
      "notRegistered": "Här kan du som registrerad användare lägga till information om ditt hem så att vi bättre kan förstå dina behov.",
      "st": "gata",
      "title": "Mina adresser"
    },
    "notes": {
      "addNoteToOrder": "Lägg till en anteckning i beställningen...",
      "cleaningNotes_cleaning": "Anteckningar om städning",
      "cleaningNotes_massage": "Anteckningar om massage",
      "cleaningNotes_other": "Anteckningar om tjänst",
      "exampleNote_cleaning": "“Jag har stenbänkskivor i köket”\n“Jag har svarta skåpluckor som lätt får fingeravtryck”",
      "exampleNote_massage": "“Vänligen gör en mildare ryggmassage”\n“Vänligen undvik höger knä efter operation”",
      "exampleNote_other": "“Vänligen värma upp ...”",
      "notes": "Anteckningar",
      "whatWeShouldKnow_cleaning": "Finns det något vi bör veta för att möta dina förväntningar?",
      "whatWeShouldKnow_massage": "Finns det något vi bör veta innan vi påbörjar tjänsten? T.ex. en lista över tidigare sjukdomar etc.",
      "whatWeShouldKnow_other": "Ange all information och alla instruktioner som hjälper oss att utföra tjänsten framgångsrikt"
    },
    "notAvailableLocation": {
      "notAvailableLocationDescription": "Våra tjänster är inte tillgängliga på denna adress. Om du vill att vi ska dyka upp - låt oss veta!",
      "notAvailableLocationTtile": "Tyvärr, vi är inte tillgängliga på denna plats",
      "proposeCity": "Jag vill ha Stepapp i mitt område",
      "proposeCityTitle": "Jag vill ha Stepapp"
    },
    "notificationsCheck": {
      "description": "Missade inte information om rabatter och viktiga meddelanden om din städning.",
      "enableNotifications": "Aktivera aviseringar",
      "secondDescription": "Aktivera aviseringar för att få information om framstegen i din tjänst.",
      "secondTitle": "Missade inte meddelanden.",
      "title": "Vill du veta om rabatter?"
    },
    "oneTimePasswordForm": {
      "description": "Ange koden från SMS som vi skickade till dig på %{phoneNumber}",
      "sendAgain": "Skicka igen",
      "sendAgainIn": "Skicka igen (%{countdown}s.)",
      "title": "Ange kod från sms"
    },
    "paymentFailed": {
      "description": "Vi kunde inte dra medel för att betala din prenumeration. Uppdatera betalningsmetoden eller kontakta oss om du vill ändra eller avbryta den.",
      "title": "Betalningen misslyckades"
    },
    "payments": {
      "cantRemoveCardDescription": "Du har pågående tjänster. För att ta bort kortet, betala för städningen eller kontakta supporten.",
      "cantRemoveCardTitle": "Det går inte att ta bort kortet",
      "credits": "Krediter",
      "editPaymentInfo": "Redigera betalningsinformation för specifika bokningar på detaljsidan för varje bokning på skärmen 'Mina bokningar'",
      "finalized": "Avslutad",
      "noTransactions": "Inga transaktioner",
      "paid": "Betalt",
      "failed": "Misslyckades",
      "savedCards": "Sparade kort",
      "stepappWallet": "Stepapp plånbok: %{balance}",
      "title": "Betalningsmetoder",
      "transactionHistory": "Transaktionshistorik"
    },
    "phoneForm": {
      "description_login": "På vilket nummer ditt Stepapp-konto är registrerat",
      "description_register": "Vi behöver detta för att kunna kontakta dig angående din bokning.",
      "title": "Ange ditt telefonnummer"
    },
    "pickCity": {
      "changeCity": "Ändra stad",
      "changeCountry": "Ändra land",
      "description": "Stepapp är för närvarande tillgängligt i städerna som anges nedan.",
      "loginTitle": "Välj staden där du för närvarande bor.",
      "registerTitle": "Välj staden där du för närvarande bor."
    },
    "predefinedProfile": {
      "experienceTitle": "Min erfarenhet...",
      "lastReviews": "Senaste recensioner",
      "recommendationsTitle": "Om mig",
      "finishedJobs": "%{count} utförda tjänster",
      "customerReviews": "%{count} kundrecensioner",
      "learnMoreVerification": "Lär dig mer om vår verifierings- och utbildningsprocess i Stepapp.",
      "readMore": "Läs mer",
      "weCareWhoComes": "Vi bryr oss om vem som kommer in i ditt hem.",
      "workerBadgeDescription_training": "%{name} har genomgått vår utbildning inom kvalitet, arbetsregler och hygien.",
      "workerBadgeDescription_safety": "%{name} är verifierad av oss och uppfyller våra säkerhetskrav.",
      "workerBadgeTitle_training": "Utbildning",
      "workerBadgeTitle_safety": "Säkerhet"
    },
    "profile": {
      "removeCard": "Ta bort kort",
      "removeCardExplanation": "Att ta bort kortet kommer att ta bort det från ditt konto. Det kommer inte längre vara tillgängligt för betalning.",
      "title": "Din Profil",
      "totalOrders_zero": "%{count} beställd jobb",
      "totalOrders_one": "%{count} beställda jobb",
      "totalOrders_few": "%{count} beställda jobb",
      "totalOrders_other": "%{count} beställda jobb"
    },
    "redeemCoupon": {
      "add": "Lägg till",
      "creditTitle": "Ange laddningskod",
      "voucherTitle": "Ange kampanjkod"
    },
    "reviews": {
      "noReviews": "Vi kunde inte hämta recensioner. Försök igen senare.",
      "numberOfReviews": "Antal recensioner",
      "onlyVerifiedReviews": "Endast verifierade recensioner",
      "orderCleaning": "Beställ städning",
      "trueReviews": "Alla våra betyg har lämnats av riktiga kunder efter utförd tjänst.",
      "star": "Stjärna",
      "star_plural": "Stjärnor",
      "star_many": "Stjärnor"
    },
    "service": {
      "additionalServices": "Vad mer kan vi göra för dig? 🧹",
      "additionalServicesDescription": "Du kan ändra frekvensen av extra tjänster efter första beställningen",
      "addressExplanationForVerification": "Ange adressen för att verifiera tillgängligheten av våra tjänster. På följande steg kan du lägga till ytterligare information.",
      "autocompleteInfo": "<0>Skriv in hela gatunamnet</0> för att verifiera tillgängligheten av våra tjänster. I de följande stegen kan du lägga till ytterligare information.",
      "averageCleaningTime_cleaning": "Ungefärlig städtid",
      "averageCleaningTime_massage": "Ungefärlig massagetid",
      "averageCleaningTime_other": "Ungefärlig tjänstetid",
      "averageCleaningTimeDescription": "Detta är en uppskattad städtid eftersom vi vet att varje hem är annorlunda. Om det visar sig att mer tid behövs på platsen, informerar vi dig i förväg och ber om godkännande.",
      "backToHome": "Tillbaka till startsidan",
      "changeAddress": "Ändra adress",
      "chooseAddress": "Välj adress",
      "chooseServiceAdjustedToYourNeeds": "Välj en tjänst anpassad efter dina behov",
      "happyCustomers": "Nöjda kunder",
      "howOften": "Hur ofta?",
      "howOftenDescription": "Alltid samma pålitliga person. Prova utan uppsägningstid.",
      "includedInService": "Inkluderat i tjänsten!",
      "loader": "Ett ögonblick,\nvi bearbetar din beställning",
      "newAddress": "Ny adress",
      "nextDataAddress": "Nästa - datum och adress",
      "pickOrCreateAddress": "Välj en adress från sparade hem eller lägg till en ny",
      "priceForService": "Pris för tjänsten",
      "reservationError": "Hoppsan! Något gick fel",
      "reservationErrorDescription": "Försök igen senare eller kontakta vår kundtjänst",
      "reservationSuccess": "Toppen! Din bokning är bekräftad",
      "reservationSuccessDescription": "Nu kan du se den i din kalender och följa arbetets framsteg",
      "reviews": "Recensioner om Stepapp",
      "seeDetails": "Se detaljer",
      "seeLastReviews": "Se Senaste Recensioner",
      "selectAvailableOptions": "Välj tillgängliga alternativ för att se beställningsdetaljer",
      "serviceDateInfo": "Gratis datumändring upp till %{hours} timmar före din bokning börjar.",
      "serviceInsurance": "Din städning är försäkrad för\n%{amount}.",
      "serviceProtects": "Bokningen skyddas",
      "serviceRange": "Tjänstens omfattning",
      "showCalendar": "Visa Kalender",
      "showMoreServices": "Visa Fler Tjänster",
      "subscriptionExplanationForEdit": "Kom ihåg att du senare kan ändra regelbunden städning.",
      "whatKindOfServiceYouNeed": "Vilken typ av tjänst behöver du?",
      "whatServiceIncludes": "Vad ingår i tjänsten?",
      "whichAddress": "Vilken adress ska vi dyka upp på?",
      "whichAddressDescription": "Välj en av de sparade adresserna eller lägg till en ny."
    },
    "serviceAcceptedOverlay": {
      "thankYou": "Tack!",
      "reviewSubmitted": "Din recension har skickats in. Varje synpunkt hjälper oss att förbättra våra tjänster."
    },
    "serviceCalendar": {
      "chooseHour": "Välj en tid som passar dig",
      "description": "Välj datum och tid för att påbörja tjänsten",
      "title": "När börjar vi?"
    },
    "serviceCard": {
      "canceled": "Avbruten",
      "details": "Detaljer",
      "rateAndAccept": "Betygsätt och acceptera arbetet",
      "showProgress": "Visa framsteg",
      "today": "Idag",
      "type_oneTime": "Engångs",
      "type_subscription": "Prenumeration",
      "worker": "Arbetare"
    },
    "serviceConfirmation": {
      "completedServicePhoto": "Tjänsten har utförts. Vi har tagit ett foto som bekräftar vår närvaro på platsen. Det är synligt endast för dig och vår personal.",
      "doYouAcceptService": "Accepterar du att tjänsten utförs?",
      "report": "Rapportera problem"
    },
    "serviceDetails": {
      "additionalInfo": "Ytterligare instruktioner för leverantören",
      "addMoreServices": "Lägg till fler tjänster",
      "calendarChangeDateInfo": "Vi tar ut en avgift om du ändrar datumet för en engångsservice, mindre än %{hoursBeforeFee} timmar före det ursprungliga datumet.",
      "cancellationRule": "Du kan avboka och redigera tjänsten upp till %{hoursBeforeFee} timmar i förväg och få 100% återbetalning. Avbokning efter denna tid kan medföra extra kostnader.",
      "cancellationRules": "Avbokningsregler",
      "cancelService": "Avbryt denna tjänst",
      "changeServiceDetails_cleaning": "Ändra städdetaljer",
      "changeServiceDetails_massage": "Ändra massagedetaljer",
      "changeServiceDetails_other": "Ändra tjänstedetaljer",
      "changeDate": "Ändra datum %{fee}",
      "changeDate2": "Ändra datum",
      "changeDateInfo": "Du kan ändra datum och tid för tjänsten gratis upp till %{hoursBeforeFee} timmar före den bokade tiden.",
      "changeDateIntercomMessage": "God morgon, jag skulle vilja ändra datum för min bokning från ... till ...",
      "changeDetails": "Ändra detaljer",
      "chat": "Starta chatt",
      "close": "Stäng",
      "confirmDeleteService": "Är du säker? Ytterligare tjänst kommer inte att utföras",
      "currentPrice": "Nuvarande pris",
      "deleteService": "Radera %{service}?",
      "fee": "(avgift %{fee})",
      "fetchReservationError": "Något gick fel när vi hämtade detaljerna för din bokning. Gå tillbaka till bokningskalendern och försök igen. Om problemet kvarstår, kontakta oss.",
      "hour": "Timme",
      "hours": "Timmar",
      "manage": "Hantera",
      "newPrice": "Nytt pris",
      "orderFor": "Beställning för:",
      "paymentForm": "Betalningsformulär",
      "questionNotFound": "Det gick inte att hitta frågan att uppdatera",
      "service": "Tjänst",
      "showCancellationRules": "Visa våra avbokningsregler",
      "submitChangeConfirmation": "Tjänstens datum har sparats!",
      "submitChangeLoader": "Ett ögonblick, vi sparar ändringarna",
      "submitDetailsConfirmation": "Ändringar i tjänsten har sparats",
      "subscriptionChangeDateInfo": "Prenumeranter har flexibilitet! För städning inom prenumeration kan du ändra gratis upp till 36 timmar före tjänsten!",
      "total": "Totalt",
      "totalPaymentInfo": "Betalningen kommer att dras först på städdagen, men medlen kommer att reserveras 48 timmar före datumet.",
      "type_oneTime": "Engångs",
      "type_subscription": "Prenumeration",
      "writeToUs": "skriv till oss"
    },
    "serviceRating": {
      "addPublicReview": "Lägg till en offentlig recension",
      "answersNotShared": "Svaren kommer inte att delas med arbetaren.",
      "asYourWorker": "som din arbetare?",
      "cleanLeaveRating": "Rent? Lämna betyg!",
      "doYouWantToKeep": "Vill du behålla",
      "enterText": "Ange text",
      "followedInstructions": "Följde arbetaren dina instruktioner?",
      "giveYouComment": "Ge oss dina kommentarer",
      "howDoYouRateYourExperience": "Hur skulle du betygsätta din upplevelse?",
      "keep": "Behåll",
      "leaveOpinion": "Lämna åsikt",
      "leaveOpinionAndRating": "Dela din åsikt och betygsätt tjänsten.",
      "leaveRating": "Lämna betyg",
      "newWorker_description": "Du kommer att se en ny arbetare 48 timmar innan nästa tjänst",
      "newWorker_title": "OK, vi kommer att tilldela någon annan till nästa tjänst",
      "optional": "Valfritt",
      "rating1": "Dålig servicekvalitet",
      "rating2": "Dåligt",
      "rating3": "Tjänsten uppfyllde inte mina förväntningar",
      "rating4": "Det var OK, men behöver förbättras",
      "rating5": "Tjänsten uppfyllde mina förväntningar till 100%",
      "sorryToHearThat": "Tråkigt att höra det.",
      "touchStarsToLeaveReview": "Tryck på stjärnorna för att lämna en recension.",
      "wasOnTime": "Var arbetaren på tid?",
      "wasPrepared": "Var arbetaren förberedd för jobbet?",
      "wantTheSameWorkerAgain": "Vill du ha samma arbetare igen?"
    },
    "serviceRealization": {
      "chat": "Chatt",
      "checkAndConfirm": "Kontrollera och bekräfta resultat",
      "daysLeft": "%{daysLeft} dag kvar",
      "daysLeft_plural": "%{daysLeft} dagar kvar",
      "info": "Info",
      "rateTheServiceWithin": "Betygsätt tjänsten inom 7 dagar",
      "report": "Rapportera",
      "serviceCompleted": "Tjänsten slutförd!",
      "serviceStatus": "Tjänststatus",
      "statusChoosen": "Arbetaren tilldelad",
      "statusChoosenDescription": "Vi har valt en person som kommer att utföra tjänsten hemma hos dig! För prenumerationstjänster kommer det alltid att vara samma person!",
      "statusInProgress": "Pågående tjänst",
      "statusInProgressDescription": "Arbetaren arbetar redan med städningen! När städningen är klar kommer vi be dig om din åsikt!",
      "statusOnTheWay": "Arbetaren är på väg",
      "statusOnTheWayDescription": "Det blir idag! Snart kommer arbetaren för att fräscha upp ditt hem!",
      "statusWaitingForAccpetance": "Din beställning har utförts!",
      "still": "fortfarande"
    },
    "serviceSummary": {
      "addCreditDebitCard": "Lägg till kredit- eller betalkort",
      "additionalServices": "Ytterligare tjänster",
      "cardPayment": "Kortbetalning",
      "changeCoupon": "Ändra kupong",
      "changeDate": "Ändra datum",
      "confirmAndOrder": "Bekräfta och betala",
      "choosePaymentMethod": "Välj betalningsmetod",
      "coupon": "Kupong \"%{coupon}\"",
      "description": "Granska din beställning igen och se till att allt stämmer",
      "enterCoupon": "Ange kupong",
      "frequency_EVERY_MONTH": "Varje månad",
      "frequency_EVERY_TWO_WEEKS": "Varannan vecka",
      "frequency_EVERY_WEEK": "Varje vecka",
      "frequency_ONE_TIME": "En gång",
      "grossPriceIncludingVAT": "Priset ovan är bruttopriset, inklusive moms %{vat}%",
      "howOften": "Hur ofta?",
      "importantInformation": "Viktig information",
      "iWillBeThere": "Jag kommer vara där",
      "logIn": "Logga in",
      "loginToViewDetails": "Logga in eller registrera dig för att göra en beställning",
      "orderingFor": "Beställer för",
      "orderingForDescription": "Angiven information kommer att sparas i din profil som 'Min adress'",
      "paidOnServiceDay": "Betalning på tjänstedagen",
      "paymentMethod": "Betalningsmetod",
      "paymentNotice": "Efter att du har lagt beställningen kommer vi att utföra en verifieringsbetalning motsvarande beställningens belopp. Den kommer att återbetalas inom högst 10 minuter. Den faktiska reservationsavgiften debiteras först efter att tjänsten har slutförts.",
      "paymentNow": "Betala nu",
      "paymentNowInfo": "Vid bokning med genomförande inom 48 timmar, reserverar vi medlen vid bokningstillfället.",
      "paymentTerms": "Betalningsvillkor finns tillgängliga på %{link}",
      "recurringPayment": "Återkommande betalningar",
      "registerAndOrder": "Registrera dig och lägg din beställning",
      "sendSMSCode": "Skicka SMS-kod",
      "SMSInfo": "Vi skickar en sms-kod till det angivna telefonnumret. Ange koden för att bekräfta inloggning eller registrering.",
      "subscriptionDiscount": "Prenumerationsrabatt",
      "title": "Sammanfattning",
      "toPay": "Att betala",
      "total": "Totalt",
      "usedVoucher": "Använd kupong",
      "wantEnterCoupon": "Vill du lägga till en kupong?",
      "webCardModalTitle": "Detta är sista steget. Lägg till kortet och njut av ett rent hem. 🏠",
      "webPaymentInfo": "Ditt personuppgiftsansvariga är Stepapp Sp. z.o.o. Betalningsansvarig är Stripe. Vi kommer aldrig att dra några pengar utan ditt förhandsmedgivande, och du har en 7-dagars klagomålsperiod för alla transaktioner.",
      "whatIfSomethingsGoesWrong": "Vad händer om något går fel?",
      "whatIfSomethingsGoesWrongDescription": "Om du inte är nöjd med tjänsten, garanterar vi att den kommer att utföras på nytt av de mest erfarna personerna i vårt team. Självklart utan extra kostnad.",
      "whatNow": "Vad händer nu?",
      "whatNowDescription": "Efter att du har bekräftat din beställning kommer vi att matcha dig med den bästa utföraren i ditt område baserat på dina preferenser. Du kommer att få träffa dem och kunna kontakta dem 48 timmar innan uppdraget påbörjas.",
      "when": "När?",
      "yourCardWillBeLinkedTo": "Ditt kort kommer att kopplas till ditt Stepapp-konto och användas för framtida nedladdningar av beställda tjänster. Du kan alltid ändra det i inställningarna.",
      "yourDataIsSecureThanksTo": "Dina data är säkra tack vare",
      "yourDataIsSecureThanksToStripe": "Dina data är säkra tack vare Stripe Ltd.",
      "yourStepappWallet": "Din Stepapp Plånbok"
    },
    "settings": {
      "accountDeleted": "Startade processen att ta bort kontot. Vi måste kontrollera om du har några obetalda transaktioner. Ditt konto och all relaterad data kommer att tas bort inom 7 dagar.",
      "cancellationRules": "Avbokningsregler",
      "deleteAccount": "Ta bort konto",
      "discountsAndPromotions": "T.ex. rabatter, erbjudanden och kampanjer",
      "email": "E-postadress",
      "logOut": "Logga ut",
      "notifications": "Aviseringar",
      "newsletterAndPromotions": "Nyhetsbrev och Kampanjer",
      "others": "Övrigt",
      "phoneNumber": "Telefonnummer",
      "privacyPolicy": "Integritetspolicy",
      "pushNotifications": "Push-aviseringar i appen",
      "informationAboutReservation": "Inkluderar: information om dina bokningar, meddelanden från kundsupport",
      "reminderAboutReservation": "Inkluderar: påminnelser om bokningar, brådskande meddelanden från kundsupport",
      "removeAccountExplanation": "Ditt konto kommer att tas bort. Detta kan inte ångras.",
      "smsNotifications": "SMS-meddelanden",
      "title": "Inställningar",
      "updateEmailAddress": "Uppdatera e-postadress",
      "wantToChangePhoneNumber": "Om du vill ändra ditt telefonnummer,"
    },
    "support": {
      "call": "Ring",
      "contactOptions": "Kontaktalternativ:",
      "sendEmail": "Skicka E-post",
      "startChat": "Starta Chatt",
      "title": "Kontakta oss"
    },
    "unmatched": {
      "description": "Vi kan inte hitta sidan du letar efter. Försök att gå tillbaka till föregående sida eller kontakta oss för mer information.",
      "title": "Hoppsan,\ninget här..."
    },
    "welcome": {
      "customerSupportDescription": "Vi finns tillgängliga för dig 7 dagar i veckan via chatt och e-post, och vi kommer att svara på varje problem som du inte kan lösa via appen.",
      "customerSupportTitle": "Kundsupport alltid tillgänglig.",
      "letsStart": "Låt oss börja!",
      "orderCleaningDescription": "Beräkna städningen av ditt hem, välj tillgängligt datum och beställ tjänsten när som helst, 24/7.",
      "orderCleaningTitle": "Enkelt och snabbt sätt att beställa städning.",
      "trustedTeamDescription": "Varje städare på Stepapp har genomgått flera dagars utbildning och städar enligt specifika regler och standarder.",
      "trustedTeamTitle": "Pålitligt, erfaret och utbildat team."
    }
  },
  "validation": {
    "address": "Ange en giltig adress",
    "blank": "Fältet kan inte vara tomt",
    "city": "Ange rätt stadsnamn",
    "companyName": "Ange företagsnamn",
    "date": "Välj datum för tjänsten",
    "email": "Ange en korrekt e-postadress",
    "firstName": "Ange ditt förnamn",
    "homeType": "Välj hus typ",
    "hour": "Välj tid för tjänsten",
    "invalid": "Ange korrekta uppgifter",
    "keyInfo": "Beskriv var du kommer lämna nyckeln",
    "lastName": "Ange ditt efternamn",
    "maxSurface": "Den maximalt stödda ytan är %{maxSize}m2",
    "minSurface": "Minsta hanterbara yta är %{minSize}m2",
    "nipNumber": "Ange korrekt NIP-nummer",
    "numberOrHousing": "Ange lägenhets-/husnummer",
    "phone": "Ange korrekt telefonnummer",
    "pickAddress": "Välj adress",
    "pickOption": "Välj ett av alternativen",
    "postalCode": "Ange korrekt postnummer",
    "required": "Obligatoriskt",
    "smsOrPhoneNumber": "Felaktig SMS-kod eller telefonnummer"
  },
  "verification": {
    "closePage": "Denna sida kommer att stängas automatiskt om 10 sekunder",
    "paymentVerificationConfirmed": "Din betalning har bekräftats",
    "paymentVerificationFailed": "Bekräftelsen misslyckades",
    "retryVerification": "Försök igen eller använd en annan betalningsmetod."
  }
}
